import { RouterService } from './../router.service';
import { Component, OnInit } from '@angular/core';
import { DonateData } from '../donate-data';
import { AppComponent } from '../app.component';
import { ActivatedRoute } from '@angular/router';
import { SendMessageService } from '../send-message.service';
import { DonateChangeService } from '../donate-change.service';
import { SettingService } from '../setting.service';
import { SettingData } from '../setting-data';
import { ControlService } from '../controll-screen/control.service';
import { ControlData, ControlNext } from '../controll-screen/control-data';
import { CookieService } from 'ngx-cookie-service';
import { CheckIdService } from '../check-id.service';
import { Paho } from 'ng2-mqtt/mqttws31';
import { GuidService } from '../guid.service';

@Component({
  selector: 'app-play-video-screen',
  templateUrl: './play-video-screen.component.html',
  styleUrls: ['./play-video-screen.component.scss']
})
export class PlayVideoScreenComponent implements OnInit {

  donateState: number; // 0: waiting, 1: patron, 2: donate, 3: play vedio
  player: YT.Player;
  ytEvent: any;
  playerVars = {
    cc_lang_pref: 'en'
  };
  yid = '';
  id: string;
  name: string;
  donate: number;
  msg: string;
  currentDonate: DonateData;
  videoTimeLeft = 0;
  videoInterval: any;
  patronTimeLeft = 0;
  patronInterval: any;
  donateTimeLeft = 0;
  donateInterval: any;
  idleTimeLeft = 0;
  idleInterval: any;
  settingData: SettingData;
  isPlay = false;
  isLoop: boolean;
  videoVolume: number;
  voiceVolume: number;
  isControlOpened: boolean;
  waitingTimeLeft: number;
  checkIDState = 0;
  client: any;
  videoPlayTime: 0;
  checkVideoPlayInterval: any;
  isSecondPatronTurn = false;
  constructor(private appComponent: AppComponent, private activateRouter: ActivatedRoute, private donateChange: DonateChangeService,
              private sendMessage: SendMessageService, private settingService: SettingService, private controlService: ControlService,
              private cookieService: CookieService, private checkIDService: CheckIdService, private routerService: RouterService) {
    this.isLoop = false;
    this.donateState = 0;
    this.donateChange.donateDataChange.subscribe((value) => {
      if (value) {
        this.isSecondPatronTurn = false;
        this.currentDonate = value;
        this.isPlay = false;
        this.onDonateStateChange(1);
        if ( this.currentDonate.yt !== '') {
          this.yid = this.parserYTID(this.currentDonate.yt);
          this.videoTimeLeft = this.currentDonate.time;
          this.pauseVideoTimer();
        }
        if (this.checkVideoPlayInterval) {
          clearInterval(this.checkVideoPlayInterval);
        }
        this.videoPlayTime = 0;
      }
    });
    this.settingService.settingDataChange.subscribe((settingData) => {
      this.settingData = settingData;
      if ( this.settingData.isloop || this.cookieService.get('isLoop') ){
        this.cookieService.set('isLoop', '1', 999999, '/');
        this.isLoop = true;
      }
    });
    this.controlService.timeChange.subscribe((value) => {
      this.videoTimeLeft = value;
      if (this.videoTimeLeft === 0) {
        this.yid = this.parserYTID('');
        this.pausePatronTimer();
        this.pauseVideoTimer();
        this.pauseDonateTimer();
        this.onDonateStateChange(0);
      }
    });
    this.controlService.videoVolumeChange.subscribe((value) => {
      this.videoVolume = value;
      if (this.player) {
        this.player.unMute();
        this.player.setVolume(value);
      }
    });
    this.controlService.voiceVolumeChange.subscribe((value) => {
      this.voiceVolume = value;
    });
    this.controlService.videoStateChange.subscribe((value) => {
      if (this.player) {
        if (value === 1) {
          this.player.playVideo();
        }
        if (value === 2) {
          this.player.pauseVideo();
        }
      }
    });
    this.controlService.controlStateChange.subscribe((value) => {
      if (value === 1) {
        this.isControlOpened = true;
      } else {
        this.isControlOpened = false;
      }
    });
    checkIDService.checkStateChange.subscribe((value) => {
      if (value === 1) {
        this.checkIDState = 1;
      } else {
        alert('此ID不存在');
        this.routerService.GoToHomePage();
      }
    });
  }

  ngOnInit(): void {
    this.videoVolume = 50;
    this.isControlOpened = false;
    this.id = this.activateRouter.snapshot.paramMap.get('id');
    this.client = new Paho.MQTT.Client(this.appComponent.mqttbroker, Number(8084), GuidService.newGuid());
    const will = new Paho.MQTT.Message(JSON.stringify({id: this.id, msg: 'off'}));
    will.destinationName = 'status/send';
    will.qos = 0;
    this.client.connect({ onSuccess: this.appComponent.onConnect.bind(this), useSSL: true, willMessage: will });
    this.appComponent.client.subscribe('check_id/' + this.id + '/res');
    this.appComponent.client.subscribe('setting/' + this.id + '/res');
    this.appComponent.client.subscribe('control/' + this.id + '/res');
    this.appComponent.client.subscribe('donate/' + this.id + '/res');
    this.currentDonate = this.appComponent.currentDonateData;
    this.appComponent.client.subscribe('account/' + this.id + '/res');
    this.appComponent.client.subscribe('control_msg/' + this.id + '/send');
    this.appComponent.client.subscribe('control_msg/' + this.id + '/res');
    this.appComponent.client.subscribe('control_song/' + this.id + '/res');
    this.appComponent.client.subscribe('window_check/' + this.id + '/res');
    const loginData = new ControlData(this.id, 'login');
    let message = JSON.stringify(loginData);
    this.sendMessage.sendMessage(this.appComponent.client, message, 'account/' + this.id + '/send');
    const checkOpenData = {id: this.id, msg: 'check'};
    message = JSON.stringify(checkOpenData);
    this.sendMessage.sendMessage(this.appComponent.client, message, 'window_check/' + this.id + '/send');
    const statusData = {id: this.id, msg: 'on'};
    message = JSON.stringify(statusData);
    this.sendMessage.sendMessage(this.appComponent.client, message, 'status/send');
    this.sendMessage.sendMessage(this.appComponent.client, JSON.stringify({id: this.id}), 'check_id/send');
    // this.startWaitingTimer(2);
  }


  next(): void {
    if (!this.isControlOpened){
      this.pauseVideoTimer();
      let contorlData: ControlNext;
      if (this.currentDonate){
        contorlData = new ControlNext(this.id, 'next');
      } else {
        contorlData = new ControlNext(this.id, 'endnext');
      }
      const message = JSON.stringify(contorlData);
      this.sendMessage.sendMessage(this.appComponent.client, message, 'control_next/' + this.id + '/send');
    }else if (this.videoPlayTime === 0) {
      this.pauseVideoTimer();
      let contorlData: ControlNext;
      if (this.currentDonate){
        contorlData = new ControlNext(this.id, 'next');
      } else {
        contorlData = new ControlNext(this.id, 'endnext');
      }
      const message = JSON.stringify(contorlData);
      this.sendMessage.sendMessage(this.appComponent.client, message, 'control_next/' + this.id + '/send');
    }
  }

  savePlayer(player) {
    console.log('save');
    this.player = player;
    this.player.setSize(0, 0);
    this.player.loadVideoById(this.yid, this.currentDonate.stime);
    this.player.playVideo();
    setTimeout(this.player.playVideo, 2);
    this.checkVideoStartTimer();
  }

  onDonateStateChange(donateState: number) {
    console.log('change ' + donateState);
    this.donateState = donateState;
    if (this.donateState === 0) {
    }
    if (this.donateState === 1) {
      if (this.currentDonate.pic2 !== '') {
        this.startPatronTimer(3);
      } else {
        this.startPatronTimer(1);
      }
    }
    if (this.donateState === 2) {
      this.startDonateTimer(5);
      // voice.speak(this.currentDonate.msg, this.voiceVolume);
    }
    if (this.donateState === 3) {
      this.isPlay = true;
    }
  }

  onStateChange(event) {
    this.ytEvent = event.data;
    console.log(event);
    if (!event.data) {
      if (this.cookieService.check('isLoop')) {
        this.player.playVideo();
      } else {
        this.onDonateStateChange(0);
        this.next();
      }
    }
    if (this.ytEvent === 1) { // 開始播
      this.startVideoTimer(this.videoTimeLeft);
      this.player.unMute();
      this.player.setVolume(this.videoVolume);
    }
    if (this.ytEvent === 3) {
      this.player.setSize(800, 600);
      this.player.playVideo();
      this.isPlay = true;
    }
    if (this.ytEvent === 2) { // 按暫停
      this.pauseVideoTimer();
    }
    if (this.ytEvent === 0) { // 初始化成功
      // this.next();
    }
    if (this.ytEvent === 5) { // 被中斷(stopVideo())
      this.player.destroy();
      this.onDonateStateChange(0);
      this.next();
    }
  }

  parserYTID(url: string): string {
    const videoID = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    if (videoID != null) {
      return videoID[1];
    } else {
      return '';
    }
  }

  startVideoTimer(time: number) {
    this.pauseAllTimer();
    this.videoTimeLeft = time;
    this.videoInterval = setInterval(() => {
      this.videoPlayTime++;
      if (this.videoTimeLeft > 0) {
        this.videoTimeLeft--;
      } else {
        this.pauseVideoTimer();
        this.player.stopVideo();
        return;
      }
    }, 1000);
  }

  pauseVideoTimer() {
    clearInterval(this.videoInterval);
  }

  startPatronTimer(time: number) {
    this.pauseAllTimer();
    this.patronTimeLeft = time;
    this.patronInterval = setInterval(() => {
      if (time === 3 &&　this.patronTimeLeft === 2) {
        this.isSecondPatronTurn = true;
      }
      if (this.patronTimeLeft > 0) {
        this.patronTimeLeft--;
      } else {
        this.onDonateStateChange(2);
        this.pausePatronTimer();
      }
    }, 1000);
  }

  pausePatronTimer() {
    clearInterval(this.patronInterval);
  }

  startDonateTimer(time: number) {
    this.pauseAllTimer();
    this.donateTimeLeft = time;
    this.donateInterval = setInterval(() => {
      if (this.donateTimeLeft > 0) {
        this.donateTimeLeft--;
      } else {
        if (this.currentDonate.yt !== '') {
          this.onDonateStateChange(3);
          this.pauseDonateTimer();
        }
        else {
          this.onDonateStateChange(0);
          this.next();
          this.pauseDonateTimer();
        }
      }
    }, 1000);
  }

  pauseDonateTimer() {
    clearInterval(this.donateInterval);
  }

  startWaitingTimer(time: number) {
    this.waitingTimeLeft = time;
    const interval = setInterval(() => {
      if (this.waitingTimeLeft > 0){
        this.waitingTimeLeft--;
      } else {
        this.next();
        clearInterval(interval);
      }
    }, 1000);
  }

  checkVideoStartTimer() {
    this.checkVideoPlayInterval = setInterval(() => {
      if (this.videoPlayTime === 0) {
        this.next();
      }
      clearInterval(this.checkVideoPlayInterval);
    }, 5000);
  }

  setVolume(volume: number) {
    if (this.isPlay === true) {
      this.player.setVolume(volume);
    }
  }

  pauseAllTimer() {
    this.pausePatronTimer();
    this.pauseVideoTimer();
    this.pauseDonateTimer();
  }
}
